import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16f6bb3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-wild-sand p-x4 mb-x6 mx-auto max-w-750" }
const _hoisted_2 = { class: "text-12" }

import { computed } from 'vue';
import type { Component } from 'vue';
import {
    BaseProductItem, BasketDeliverableType,
    CheckOutDeliverable,
    CheckOutDeliverableWithAddress,
    ClickAndCollectCheckOutDeliverable,
    CustomerDeliveryCheckOutDeliverable, EarliestCustomerDeliveryDates, LabelWithNamedArguments,
    PickUpCheckOutDeliverable,
} from '@/storecontext/shared/api/server-apis';
import CheckoutItem from '../items/CheckoutItem.vue';
import CheckoutItemSkeleton from '../items/CheckoutItemSkeleton.vue';
import { useCheckout } from '@/storecontext/checkout/useCheckout';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import { useDeliverableLineItems } from '@/storecontext/checkout/useDeliverableLineItems';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutDeliverableItems',
  props: {
    deliverable: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: CheckOutDeliverable | CheckOutDeliverableWithAddress | CustomerDeliveryCheckOutDeliverable | PickUpCheckOutDeliverable | ClickAndCollectCheckOutDeliverable;
}



const { deliveryInfo } = useCheckout();
const { deliverableLineItemsSortedByDeliveryDate } = useDeliverableLineItems();

const relatedDeliveryInfo = computed<EarliestCustomerDeliveryDates>(() => {
    return deliveryInfo.value[props.deliverable.id];
});

const skeletonOrItemComponent = computed<Component>(() => waitingForDeliveryInfo.value ? CheckoutItemSkeleton : CheckoutItem);

const sortedLineItems = computed<BaseProductItem[]>(() => deliverableLineItemsSortedByDeliveryDate(props.deliverable));
const waitingForDeliveryInfo = computed<boolean>(() => props.deliverable.type === BasketDeliverableType.CustomerDelivery && !relatedDeliveryInfo.value);

const getItemLabelByItemId = (id: number) => {
    const itemLabel = relatedDeliveryInfo.value?.labelForItems?.find((label) => label.itemId === id);
    return itemLabel?.label ?? {} as LabelWithNamedArguments;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-wrap mb-x4 last:mb-0", { 'justify-center': _unref(sortedLineItems).length === 1, 'justify-between': _unref(sortedLineItems).length > 1}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedLineItems), (item, index) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(skeletonOrItemComponent)), {
          key: item.id,
          item: item,
          class: _normalizeClass(["flex", {'mt-x4': index > 1, 'item-width': _unref(sortedLineItems).length > 1}])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(BlockLabelWithNamedArguments, {
                label: getItemLabelByItemId(item.id)
              }, null, 8, ["label"])
            ])
          ]),
          _: 2
        }, 1032, ["item", "class"]))
      }), 128))
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})